export default __webpack_public_path__ + "static/media/padelHistoryImagen.e99cefc3.jpg";